import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export function recordTarget(page, id, betriebsjahrId) {
  if (id === undefined || id === null || id === "") return null;
  const path = page === "kunden" || page === "jaeger"
    ? `/personen?modus=${page}&` : `/${page}?`;
  const year = betriebsjahrId == null || betriebsjahrId === "" ? ""
    : `&betriebsjahr_id=${encodeURIComponent(betriebsjahrId)}`;
  return `${path}selected=${encodeURIComponent(id)}${year}`;
}

export default function RecordLink({ page, id, betriebsjahrId, children }) {
  const to = recordTarget(page, id, betriebsjahrId);
  if (!to || !children) return children;
  return <Link component={RouterLink} to={to} onClick={event => event.stopPropagation()}>{children}</Link>;
}
